import analysisModule from "../analysisModule"

analysisModule.service("nodeCommandViewTripEdition", ["tripEditionModal", (tripEditionModal) => {
    return (selection, context) => {
        return tripEditionModal(selection).then(() => {
            context.refilter()
        })
    }
}])
